import shortid from "shortid";

const allComments = [
  {
    key: "UVmmFa7-f",
    type: "block",
    involved_users: [],
    comments: [],
    delete: true,
  },
  {
    key: "UVmmFa7",
    type: "block",
    involved_users: [
      {
        user_id: "user",
        profile_photo_url:
          "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
        name: "Jana Englická",
      },
    ],
    comments: [
      {
        id: "0",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-11-15T14:48:00.000Z",
        content: "This is first comment add to picture element. Thank you.",
        read_by: ["user"],
      },
    ],
  },
  {
    key: "UVmmFa7ch",
    type: "block",
    involved_users: [
      {
        user_id: "642ab56e88deeddc75130357",
        profile_photo_url:
          "https://storage.googleapis.com/topolio-profile-photos/64510534879be.jpg",
        name: "Tomáš Senk",
      },
    ],
    comments: [
      {
        id: "1",
        created_by: {
          user_id: "642ab56e88deeddc75130357",
          profile_photo_url:
            "https://storage.googleapis.com/topolio-profile-photos/64510534879be.jpg",
          name: "Tomáš Senk",
        },
        created_at: "2023-10-15T14:48:00.000Z",
        content: "This is first comment add to picture element. Thank you.",
        read_by: ["devLoc"],
      },
    ],
  },
  {
    key: "Byggju-zb",
    type: "section",
    involved_users: [
      {
        user_id: "user",
        profile_photo_url:
          "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
        name: "Jana Englická",
      },
      {
        user_id: "642ab56e88deeddc75130357",
        profile_photo_url:
          "https://storage.googleapis.com/topolio-profile-photos/64510534879be.jpg",
        name: "Tomáš Senk",
      },
      {
        user_id: "642ab56e88deeddc75130357",
        profile_photo_url:
          "https://ui-avatars.com/api/?name=J+G&color=7F9CF5&background=EBF4FF",
        name: "Jakub Gause",
      },
      {
        user_id: "user",
        profile_photo_url:
          "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
        name: "Jana Englická",
      },
      {
        user_id: "642ab56e88deeddc75130357",
        profile_photo_url:
          "https://storage.googleapis.com/topolio-profile-photos/64510534879be.jpg",
        name: "Tomáš Senk",
      },
      {
        user_id: "642ab56e88deeddc75130357",
        profile_photo_url:
          "https://ui-avatars.com/api/?name=J+G&color=7F9CF5&background=EBF4FF",
        name: "Jakub Gause",
      },
      {
        user_id: "user",
        profile_photo_url:
          "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
        name: "Jana Englická",
      },
      {
        user_id: "user",
        profile_photo_url:
          "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
        name: "Jana Englická",
      },
    ],
    comments: [
      {
        id: "2",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-10-04T10:48:00.000Z",
        content: "This section is too cluttered. Something needs to be cut.",
        read_by: ["user"],
        reactions: [
          {
            created_by: {
              user_id: "642ab56e88deeddc75130357",
              profile_photo_url:
                "https://storage.googleapis.com/topolio-profile-photos/64510534879be.jpg",
              name: "Tomáš Senk",
            },
            type: "thumb-up",
          },
        ],
      },
      {
        id: "3",
        created_by: {
          user_id: "642ab56e88deeddc75130357",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+G&color=7F9CF5&background=EBF4FF",
          name: "Jakub Gause",
        },
        created_at: "2023-10-05T08:48:00.000Z",
        content: "So I can put the gif away.",
        read_by: ["user"],
      },
      {
        id: "4",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-12-04T10:48:00.000Z",
        content:
          '<div>I tested <a class="mention" data-id="devLoc2">@Tomáš Sek</a> mention?</div>',
        read_by: ["user", "devLoc"],
      },
    ],
  },
  {
    key: "Byggju-zbf",
    type: "section",
    resolved: true,
    involved_users: [
      {
        user_id: "user",
        profile_photo_url:
          "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
        name: "Jana Englická",
      },
    ],
    comments: [
      {
        id: "5",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-10-05T09:48:00.000Z",
        content: "Delete this please!!!",
        read_by: [],
      },
      {
        id: "6",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-10-05T09:48:00.000Z",
        content: "Delete this please!!!",
        read_by: [],
      },
      {
        id: "7",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-10-05T09:48:00.000Z",
        content: "Delete this please!!!",
        read_by: [],
      },
      {
        id: "8",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-10-05T09:48:00.000Z",
        content:
          "Great progress on the user interface design! The color palette is vibrant and aligns well with our brand identity. The color palette is vibran",
        read_by: [],
      },
      {
        id: "9",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-10-05T09:48:00.000Z",
        content:
          "Great progress on the user interface design! The color palette is vibrant and aligns well with our brand identity. The color palette is vibran",
        read_by: [],
      },
      {
        id: "10",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-10-05T09:48:00.000Z",
        content:
          "Great progress on the user interface design! The color palette is vibrant and aligns well with our brand identity. The color palette is vibran",
        read_by: [],
      },
      {
        id: "11",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-10-05T09:48:00.000Z",
        content:
          "Great progress on the user interface design! The color palette is vibrant and aligns well with our brand identity. The color palette is vibran",
        read_by: [],
      },
      {
        id: "12",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-10-05T09:48:00.000Z",
        content:
          "Great progress on the user interface design! The color palette is vibrant and aligns well with our brand identity. The color palette is vibran",
        read_by: [],
      },
      {
        id: "13",
        created_by: {
          user_id: "user",
          profile_photo_url:
            "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
          name: "Jana Englická",
        },
        created_at: "2023-12-02T09:48:00.000Z",
        content:
          "Great progress on the user interface design! The color palette is vibrant and aligns well with our brand identity. The color palette is vibran",
        read_by: [],
      },
    ],
  },
];

export const getAllComments = ({ request }) => {
  const url = new URL(request.url);
  const sortBy = url.searchParams.get("sort_by");
  const resolved = url.searchParams.get("show_resolved");
  const userId = url.searchParams.get("current_user_id");
  let filter = allComments.filter(
    (item) => item.delete !== true && item.comments.length > 0
  );
  if (resolved === "false") {
    filter = filter.filter((item) => item.resolved !== true);
  }

  const compareByDate = (a, b) => {
    const dateA = new Date(a.comments[a.comments.length - 1].created_at);
    const dateB = new Date(b.comments[b.comments.length - 1].created_at);
    if (dateA > dateB) {
      return -1;
    } else if (dateA < dateB) {
      return 1;
    }
    return 0;
  };
  filter.sort(compareByDate);

  if (sortBy === "unread") {
    const compareByUnread = (a, b) => {
      const readA =
        a.comments[a.comments.length - 1].read_by.indexOf(userId) !== -1 ||
        a.comments[a.comments.length - 1].created_by.user_id === userId;
      const readB =
        b.comments[b.comments.length - 1].read_by.indexOf(userId) !== -1 ||
        b.comments[b.comments.length - 1].created_by.user_id === userId;
      if (!readA && readB) {
        return -1;
      }
      return 0;
    };
    filter.sort(compareByUnread);
  }

  return new Response(
    JSON.stringify({
      success: true,
      data: filter,
    }),
    {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const detailConversation = ({ request, params }) => {
  const url = new URL(request.url);
  const { convId } = params;
  const thisConv = allComments
    .filter((item) => item.delete !== true)
    .find((item) => item.key === convId);
  const userId = url.searchParams.get("current_user_id");

  if (
    thisConv &&
    thisConv.comments[thisConv.comments.length - 1].read_by.indexOf(userId) ===
      -1
  ) {
    thisConv.comments[thisConv.comments.length - 1].read_by.push(userId);
  }

  return new Response(
    JSON.stringify({
      success: true,
      data: thisConv,
    }),
    {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const addComment = async ({ request, params }) => {
  const { convId } = params;
  const body = await request.json();
  const { content, current_user_id, mentions } = body;

  if (convId && content !== "" && current_user_id && mentions) {
    const thisConv = allComments.find((item) => item.key === convId);
    thisConv.comments.push({
      id: shortid.generate(),
      created_by: {
        user_id: current_user_id,
        name: "Local Dev",
        profile_photo_url:
          "https://ui-avatars.com/api/?name=L&color=32363E&background=1AF1FF",
      },
      created_at: new Date(Date.now()).toISOString(),
      content: content,
      read_by: [current_user_id],
    });
  }

  return new Response("", {
    status: 200,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const postToComment = async ({ request, params }) => {
  const { commentId } = params;
  const body = await request.json();
  const { content, react, current_user_id, action, mentions } = body;

  if ((commentId && content && current_user_id, mentions)) {
    allComments.find((item) => {
      const thisComment = item.comments.find(
        (comment) =>
          comment.id === commentId &&
          comment.created_by.user_id === current_user_id
      );
      if (thisComment) {
        thisComment.content = content;
      }
    });
  }

  if (commentId && react && current_user_id) {
    allComments.find((item) => {
      const thisComment = item.comments.find(
        (comment) => comment.id === commentId
      );
      if (thisComment && thisComment.reactions) {
        const existReaction = thisComment.reactions.find(
          (reaction) =>
            reaction.type === react &&
            reaction.created_by.user_id === current_user_id
        );
        if (existReaction) {
          thisComment.reactions.splice(
            thisComment.reactions.indexOf(existReaction),
            1
          );
        } else {
          thisComment.reactions.push({
            created_by: {
              user_id: current_user_id,
              name: "Jana Englická",
              profile_photo_url:
                "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
            },
            type: react,
          });
        }
      } else if (thisComment) {
        thisComment.reactions = [
          {
            created_by: {
              user_id: current_user_id,
              name: "Jana Englická",
              profile_photo_url:
                "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
            },
            type: react,
          },
        ];
      }
    });
  }

  if (commentId && action && current_user_id) {
    allComments.find((item) => {
      const thisComment = item.comments.find(
        (comment) => comment.id === commentId
      );
      if (thisComment) {
        if (action === "mark_as_unread") {
          thisComment.read_by.splice(
            thisComment.read_by.indexOf(current_user_id),
            1
          );
        }
        if (action === "mark_as_read") {
          thisComment.read_by.push(current_user_id);
        }
      }
    });
  }

  return new Response("", {
    status: 200,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteComment = ({ params }) => {
  const { commentId } = params;

  if (commentId) {
    allComments.find((item) => {
      const thisComment = item.comments.find(
        (comment) => comment.id === commentId
      );
      if (thisComment) {
        item.comments.splice(item.comments.indexOf(thisComment), 1);
      }
    });
  }

  return new Response("", {
    status: 200,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const resolveConv = async ({ request, params }) => {
  const { convId } = params;
  const body = await request.json();
  const { resolved, current_user_id } = body;

  if (convId && current_user_id) {
    const thisConv = allComments.find((item) => item.key === convId);
    if (thisConv) {
      thisConv.resolved = resolved;
    }
  }

  return new Response("", {
    status: 200,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteConversation = ({ params }) => {
  const { convId } = params;

  if (convId) {
    const thisConv = allComments.find((item) => item.key === convId);
    if (thisConv) {
      thisConv.delete = true;
    }
  }

  return new Response("", {
    status: 200,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
